import { msg } from '@lingui/core/macro';
import { z } from 'zod';

import { listSearchSchema } from '@/shared/patterns/list-search';

import { confirmationFileFilters, costsFilters, instructionFileFilters, walletListFilters } from './wallet.filters';

// Leve de propósito: entra no arquivo da rota, que vai para o bundle inicial (A01). Só zod, Lingui,
// filtros e `shared/patterns/list-search` direto (nunca o barril).

/** Caminho do menu (`navigation.ts:187`): é por ele que `screens.byPath` acha a tela. */
export const WALLET_LIST_PATH = '/gestao-carteira/carteiras';
export const walletPath = (id: string) => `${WALLET_LIST_PATH}/${encodeURIComponent(id)}`;
export const instructionLinesPath = (id: string) => `${WALLET_LIST_PATH}/arquivos/${encodeURIComponent(id)}/remessa`;
export const confirmationLinesPath = (id: string) => `${WALLET_LIST_PATH}/arquivos/${encodeURIComponent(id)}/retorno`;

/** Abas do legado, na ordem e com o rótulo da `TabBar` (`WalletForm.tsx:12-17`, U44). */
export const WALLET_TABS = [
  { id: 'informacoes', label: msg`Informações`, icon: 'file-text' },
  { id: 'arquivos-remessa', label: msg`Arquivos remessa`, icon: 'folder-cog' },
  { id: 'arquivos-retorno', label: msg`Arquivos retorno`, icon: 'folder-cog' },
  { id: 'tarifas-convenio', label: msg`Tarifas do convênio`, icon: 'receipt-text' },
] as const;
export type WalletTab = (typeof WALLET_TABS)[number]['id'];
export const WALLET_TAB_IDS = WALLET_TABS.map((tab) => tab.id) as [WalletTab, ...WalletTab[]];

/** Caminhos antigos das abas (`router.tsx:1367-1390`): hoje redirecionam para `?tab=` (S29). */
export const LEGACY_TAB_SEGMENTS = ['arquivos-remessa', 'arquivos-retorno', 'tarifas-convenio'] as const;

/** Painel "Adicionar carteira" (`?sheet=`, U26): o voltar do navegador fecha. */
export const CREATE_SHEET = 'nova';

export const walletListSearch = listSearchSchema({
  ...walletListFilters.shape,
  sheet: z.enum([CREATE_SHEET]).optional().catch(undefined),
});
export type WalletListSearch = z.infer<typeof walletListSearch>;

/** Painéis do detalhe pela URL (U26). Atribuir e Cobrar tarifa pendente são diálogos de ação (U24). */
export const DETAIL_SHEETS = ['custos', 'carteira', 'emails', 'importar-cnab', 'gerar-cnab'] as const;
export type WalletDetailSheet = (typeof DETAIL_SHEETS)[number];

/**
 * URL do detalhe: aba (a primeira não vai para a URL), painel aberto, página e tamanho da lista da aba
 * e os filtros das abas (remessa e retorno dividem as chaves `initialDate`/`finalDate`).
 */
export const walletDetailSearch = listSearchSchema({
  tab: z.enum(WALLET_TAB_IDS).optional().catch(undefined),
  sheet: z.enum(DETAIL_SHEETS).optional().catch(undefined),
  ...instructionFileFilters.shape,
  ...confirmationFileFilters.shape,
  ...costsFilters.shape,
});
export type WalletDetailSearch = z.infer<typeof walletDetailSearch>;

/** Transações do arquivo: só a página (o legado não filtra, `FileLinesList.tsx:125-129`). */
export const fileLinesSearch = listSearchSchema({ linha: z.string().min(1).max(64).optional().catch(undefined) });
export type FileLinesSearch = z.infer<typeof fileLinesSearch>;
